import { ChangeDetectionStrategy, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';
import { DevicesStore, InstallationFeaturesStore } from '@store';
import {
  ActivateDeactivateCommands,
  DeviceIds,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsActiveProperty,
  RoomChannelsEntityCommands,
  RoomChannelsEntityProperties,
  RoomsChannelsEcoControlCommands,
  RoomsChannelsOptimizedControlCommands,
  RoomsStatusProperties,
  SrcCondensateAvoidanceCommands,
  SrcCondensateAvoidanceStatusProperties,
  SrcPumpControlStatusProperties,
} from '@vi-iot/client/index';
import { Observable } from 'rxjs';
import { Bool } from 'src/app/shared/common/enums';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-src-settings-algorithms',
  templateUrl: './src-settings-algorithms.component.html',
  styleUrls: ['./src-settings-algorithms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcSettingsAlgorithmsComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  readonly pumpControlIds = ['0', '1', '2', '3'];

  listPumpControlFeatures$: Observable<
    Feature<SrcPumpControlStatusProperties, ActivateDeactivateCommands>[]
  >;
  isSupplyChannelToggleAvailable$: Observable<boolean>;
  listFtdcFeatures$: Observable<
    Feature<SrcPumpControlStatusProperties, SrcCondensateAvoidanceCommands>[]
  >;
  obngEcoControlEntries$: Observable<
    { ecoControl: Feature<IsActiveProperty, RoomsChannelsEcoControlCommands>; circuitId: string }[]
  >;
  obngOptimizedControlEntries$: Observable<
    {
      optimizedControl: Feature<IsActiveProperty, RoomsChannelsOptimizedControlCommands>;
      circuitId: string;
    }[]
  >;
  roomChannelsEntities$: Observable<
    Feature<RoomChannelsEntityProperties, RoomChannelsEntityCommands>[]
  >;

  status$: Observable<Feature<RoomsStatusProperties, ActivateDeactivateCommands>>;
  condensateFeatures$: Observable<
    Feature<SrcCondensateAvoidanceStatusProperties, SrcCondensateAvoidanceCommands>
  >;

  readonly featurePropertyKey = FeaturePropertyKey;
  readonly bool = Bool;

  constructor(
    protected installationFeaturesStore: InstallationFeaturesStore,
    public devicesStore: DevicesStore,
    protected translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.listPumpControlFeatures$ = this.installationFeaturesStore.e3SrcPumpControlFeatures$;
    this.isSupplyChannelToggleAvailable$ = this.installationFeaturesStore.isSupplyChannelToggleAvailable$;
    this.listFtdcFeatures$ = this.installationFeaturesStore.e3FtdcFeatures$;
    this.obngEcoControlEntries$ = this.installationFeaturesStore.obngEcoControlEntries$;
    this.obngOptimizedControlEntries$ = this.installationFeaturesStore.obngOptimizedControlEntries$;
    this.roomChannelsEntities$ = this.installationFeaturesStore.roomChannelsEntities$;

    this.status$ = this.installationFeaturesStore.selectInstallationDeviceFeature<
      RoomsStatusProperties,
      ActivateDeactivateCommands
    >(FeatureNames.roomStatus, DeviceIds.RoomControl);

    this.condensateFeatures$ = this.installationFeaturesStore.selectInstallationDeviceFeature<
      SrcCondensateAvoidanceStatusProperties,
      SrcCondensateAvoidanceCommands
    >(FeatureNames.condensateAvoidance, DeviceIds.RoomControl);
  }
}
